
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.28 4.92998L17.16 2.80998C16.38 2.02998 15.11 2.02998 14.33 2.80998L11.5 5.63998L13.62 7.75998L15.74 5.63998L19.28 9.17998C20.45 7.99998 20.45 6.09998 19.28 4.92998Z' fill='#323232'/><path d='M5.48986 13.77C6.07986 14.36 7.02986 14.36 7.60986 13.77L10.0799 11.3L7.95986 9.16998L5.48986 11.64C4.89986 12.23 4.89986 13.18 5.48986 13.77Z' fill='#323232'/><path d='M14.3301 8.45999L13.6201 9.16999L10.4401 5.98999C9.85009 5.39999 8.90009 5.39999 8.32009 5.98999C7.73009 6.57999 7.73009 7.52999 8.32009 8.10999L11.5001 11.29L4.50009 18.29C3.80009 18.99 3.62009 20.13 4.21009 20.94C4.95009 21.97 6.40009 22.06 7.26009 21.2L16.4501 12C16.8401 12.39 17.4701 12.39 17.8601 12C18.2501 11.61 18.2501 10.98 17.8601 10.59L15.7401 8.46999C15.3501 8.06999 14.7201 8.06999 14.3301 8.45999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-plumbing`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPlumbing

    ```js
    <b-new-b-icon-plumbing />
    ```
</docs>


